const PREFIXO = 'filtros:';

export const TELA_LISTA_DE_SOLICITACOES = 'lista-de-solicitacoes';

export default class FiltrosDaTela {
  static salvar(tela, filtros) {
    sessionStorage.setItem(`${PREFIXO}${tela}`, JSON.stringify(filtros));
  }

  static obter(tela) {
    try {
      const filtros = sessionStorage.getItem(`${PREFIXO}${tela}`);
      return filtros ? JSON.parse(filtros) : {};
    } catch (erro) {
      return {};
    }
  }

  static remover(tela) {
    sessionStorage.removeItem(`${PREFIXO}${tela}`);
  }

  static limparTodos() {
    Object.keys(sessionStorage)
      .filter(chave => chave.indexOf(PREFIXO) === 0)
      .forEach(chave => sessionStorage.removeItem(chave));
  }
}



// WEBPACK FOOTER //
// ./src/utils/filtrosDaTela.js